import { configureStore } from '@reduxjs/toolkit';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router';
import { history } from '@xarvio/frontend-core-platform/lib/browserHistory';
import featureFlagsSlice from '@xarvio/frontend-core-state/lib/featureFlags/featureFlagsSlice';
import { rootReducer } from '@xarvio/frontend-core-state/lib/rootReducer';
import { setAppStore } from '@xarvio/frontend-core-state/lib/appStoreRef';
import type { AppFeaturesConfig } from '@xarvio/frontend-core-state/lib/featureFlags/featureFlagsSlice';

export const createAppConfig = (args?: {
  featuresConfig?: AppFeaturesConfig;
}) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(createRouterMiddleware(history)),
  });

  setAppStore(store);

  if (args?.featuresConfig) {
    store.dispatch(
      featureFlagsSlice.actions.setFeaturesConfig(args.featuresConfig),
    );
  }

  return {
    store,
    history,
  };
};
